import { render, staticRenderFns } from "./Filtering.vue?vue&type=template&id=baa5b900&scoped=true"
import script from "./Filtering.vue?vue&type=script&lang=js"
export * from "./Filtering.vue?vue&type=script&lang=js"
import style0 from "./Filtering.vue?vue&type=style&index=0&id=baa5b900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa5b900",
  null
  
)

export default component.exports